/*
 * This work has been created or enhanced by
 *   Markus Luckey, 2025, KERNBLICK GmbH
 *
 * This file is covered by the EU PL 1.2 license.
 * You may obtain a copy of the licence at
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 */

export const APP_URL = process.env.VUE_APP_APP_URL || "http://localhost:8080";

export const OIDC_AUTHORITY = process.env.VUE_APP_OIDC_AUTHORITY || undefined;
export const OIDC_CLIENT_ID = process.env.VUE_APP_OIDC_CLIENT_ID || undefined;
export const OIDC_ADMIN_ROLE = process.env.VUE_APP_OIDC_ADMIN_ROLE || undefined;
export const OIDC_USER_ROLE = process.env.VUE_APP_OIDC_USER_ROLE || undefined;

export const PROXY_URL = process.env.VUE_APP_PROXY_URL || "http://localhost:3000/check?url=";
export const CERT_CIVITAS_CRT = process.env.VUE_APP_CERT_CIVITAS_CRT || undefined;
export const CERT_CIVITAS_CRL = process.env.VUE_APP_CERT_CIVITAS_CRL || undefined;
export const CERT_CIVITAS_CRL_PEM = process.env.VUE_APP_CERT_CIVITAS_CRL_PEM || undefined;
export const DOMAIN = process.env.VUE_APP_DOMAIN || "civitas.test";

export function value(constantName) {
  // Check if the constant exists in the exported object
  if (this[constantName]) {
    return this[constantName];
  } else {
    console.debug(`Constant "${constantName}" is not defined.`);
    return undefined;
  }
}

export default {
  APP_URL,
  OIDC_AUTHORITY,
  OIDC_CLIENT_ID,
  OIDC_ADMIN_ROLE,
  OIDC_USER_ROLE,
  PROXY_URL,
  DOMAIN,
  CERT_CIVITAS_CRT,
  CERT_CIVITAS_CRL,
  CERT_CIVITAS_CRL_PEM,
  value
};
